import { Space, Tag } from 'antd';
import { useWsStore, type WsStatus } from '../store/ws';

const STATUS_LABEL: Record<
  WsStatus,
  { text: string; color: 'default' | 'processing' | 'success' | 'error' }
> = {
  idle: { text: '未连接', color: 'default' },
  connecting: { text: '连接中', color: 'processing' },
  open: { text: '已连接', color: 'success' },
  closed: { text: '已断开', color: 'error' },
};

export function StatusBar() {
  const status = useWsStore((s) => s.status);
  const lastRttMs = useWsStore((s) => s.lastRttMs);
  const lastPongAt = useWsStore((s) => s.lastPongAt);
  const offset = useWsStore((s) => s.serverClockOffsetMs);

  const label = STATUS_LABEL[status];

  return (
    <Space size="middle" style={{ fontSize: 12 }}>
      {status === 'open' ? (
        // Vercel-black solid pill for the "connected" steady state — keeps
        // the bottom-left chrome monochrome when nothing's wrong.
        <Tag
          style={{
            background: '#000000',
            color: '#ffffff',
            border: 'none',
          }}
        >
          WSS: {label.text}
        </Tag>
      ) : (
        <Tag color={label.color}>WSS: {label.text}</Tag>
      )}
      <span style={{ color: '#888' }}>
        RTT: {lastRttMs != null ? `${lastRttMs} ms` : '—'}
      </span>
      <span style={{ color: '#888' }}>
        最近心跳: {lastPongAt ? new Date(lastPongAt).toLocaleTimeString() : '—'}
      </span>
      <span style={{ color: '#888' }}>
        时钟偏移: {offset != null ? `${offset} ms` : '—'}
      </span>
    </Space>
  );
}
